import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Minimal landing page. Websites and Users now live on their own routes
// (/websites and /users); this page is intentionally light.
function Dashboard() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDTypography variant="h4" fontWeight="bold">
          Dashboard
        </MDTypography>
        <MDTypography variant="body2" color="text">
          Welcome to VW CMS.
        </MDTypography>
      </MDBox>
    </DashboardLayout>
  );
}

export default Dashboard;
